import React, { Fragment, useEffect, useState } from "react";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { patternGroupColumn } from "Constants/TableColumns";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getGroupTemplates } from "Stores/actions/properties/ShopAction";
import { REGET } from "Stores/actionTypes";

export default function ListPatternsGroup({ nameSearch, doSearch, done }) {
  const dispatch = useDispatch();
  const { list, pagination, reget, taskId } = useSelector((state) => ({
    list: state.shop.groupTemplate_List,
    pagination: state.shop.groupTemplate_Pagination,
    reget: state.shop.reget,
    taskId: state.shop.taskId,
  }));
  const [sizePerPage, setSizePerPage] = useState(pagination.Limit);
  const [currentPage, setCurrentPage] = useState(pagination.Page);
  const [total, setTotal] = useState(pagination.Total);
  const [tblData, setTblData] = useState(list);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
   (async () => {
      if (doSearch === "CLEARSEARCH") await getList();
      else if (doSearch === "DOSEARCH") {
        if (nameSearch !== 0) {
          await getList(1, sizePerPage, nameSearch);
          done();
        } else await getList();
      }
    })();
  }, [doSearch]);

  useEffect(() => {
    (async () => {
      if (reget && taskId === "GroupTemplate") {
        if (doSearch === "DOSEARCH") await getList(1, sizePerPage, nameSearch);
        else await getList();
        dispatch({
          type: REGET,
          status: false,
        });
      }
    })();
  }, [reget]);

  useEffect(() => {
    setTblData(list);
  }, [list]);

  useEffect(() => {
    setCurrentPage(pagination.Page);
    setSizePerPage(pagination.Limit);
    setTotal(pagination.Total);
  }, [pagination]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        await getList(page, sizePerPage);
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
  };

  const getList = async (
    Page = currentPage,
    Limit = sizePerPage,
    data = "NODATA"
  ) => {
    setLoading(true);
    try {
      let dataSearch = null;
      if (data !== "NODATA") {
        if (data !== "") dataSearch = { Name: data };
      } else if (nameSearch !== "")
        dataSearch = {
          Name: nameSearch,
        };
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        Limit,
        Page,
        ...dataSearch,
      };
      await dispatch(getGroupTemplates(params));
    } catch (err) {
      console.error("[onGetGroupTemplates]", err);
    }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  };

  return (
    <Fragment>
      <RemoteTable
        data={tblData}
        keyField="num"
        columns={patternGroupColumn}
        loading={loading}
        page={currentPage}
        sizePerPage={sizePerPage}
        totalSize={total}
        onTableChange={onTableChange}
      />
    </Fragment>
  );
}
